// ** Redux Imports
import rootReducer from "./rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import videosMiddleware from "../Pages/Video/VideosMiddleware";
import influencersMiddleware from "../Pages/Influencer/influencers_middleware";
import errorMiddleware from "../Shared/Errors/errorMiddleware";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat([videosMiddleware, influencersMiddleware, errorMiddleware]);
  },
});

export { store };
